<template>
  <router-view></router-view>
</template>

<script setup lang="ts">
// App component is now using script setup
</script>

<style>
@import './assets/styles.css';
</style>
